const SERVICE_TYPE = {
    "igUser": "igUser",
    "tkUser": "tkUser",
    "igPhoto": "igPhoto",
    "igVideo": "igVideo",
    "tkVideo": "tkVideo",
    "default": "default"
}

const API2 = {
    url: "https://api2.comprasocial.me",
    // url: "http://localhost:3030",
    igUserEndpoint: "/ig/user",
    tkUserEndpoint: "/tiktok/user",
    igUserMedia: "/ig/media",
    igUserVideos: "/ig/userVideos",
    tkUserFeed: "/tiktok/userFeed",
    offersTimed: "/offers/timed",
    offersNotifyEmail: "/offers/notifyEmail",
    offersFilters: "/offers/filterOptions",
}

const API = {
    url: "https://api.comprasocial.me/",
}

const INSTAGRAM_POST_LINK = "https://www.instagram.com/p/";
module.exports = {SERVICE_TYPE, API2, API, INSTAGRAM_POST_LINK};